// frontend/src/pages/ResetPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Paper,
  CircularProgress
} from '@mui/material';
import { helpSendPasswordResetEmail } from '../firebase';

const ResetPassword = () => {
  const [email, setEmail]     = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async () => {
    if (!email) {
      setMessage('Please enter your email.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      await helpSendPasswordResetEmail(email);
      setMessage('✅ Password reset email sent! Check your inbox.');
    } catch (error) {
      console.error('Password reset failed:', error);
      switch (error.code) {
        case 'auth/user-not-found':
          setMessage('No account found with that email.');
          break;
        case 'auth/invalid-email':
          setMessage('That doesn’t look like a valid email address.');
          break;
        default:
          setMessage('Error sending reset email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
        <Typography variant="h4" align="center" gutterBottom>
          Reset Password
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              value={email}
              onChange={e => setEmail(e.target.value)}
              disabled={loading}
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleResetPassword}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Send Reset Link'}
            </Button>
          </Grid>

          {message && (
            <Grid item xs={12}>
              <Typography color="text.secondary" variant="body1">
                {message}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography align="center">
              <Link to="/login">← Back to Login</Link>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ResetPassword;
